
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world-map",
      function () {
        return require("private-next-pages/world-map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world-map"])
      });
    }
  